import React, { useEffect } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import { PaymentFailedIcon } from '../../../components/icons';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { trackDwebEvent } from '../../analytics';
import { connect } from "react-redux";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const useStyles = makeStyles(theme => ({
  icon: {
    fontSize: 243
  },
  trialDiv: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  unsuccessful: {
    fontSize: 24,
    color: "#000000",
    marginBottom: 16
  },
  trialDays: {
    fontSize: 38,
    color: "#de1c22"
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: 20,
    fontSize: 18,
    fontWeight: 600,
    color: '#132529',
  },
  dialogAction: {
    justifyContent: 'center',
    paddingTop: 24,
    paddingBottom: 32
  },
  info: {
    fontSize: 16,
    marginBottom: 0
  },
  btn: {
    backgroundColor: '#5170f0',
    padding: "17px 138px 17px 137px",
    borderRadius: 8,
    borderColor: '#00875a',
    textTransform: 'capitalize',
    fontWeight: 600
  }
}));
const PaymentFailedAlertsDialog = ({ payments, cancelText, confirmText, status, confirmMessage, confirmTitle, onConfirm, confirmOpen, onClose }) => {

  const [open, setOpen] = React.useState(confirmOpen);
  const classes = useStyles();

  useEffect(() => {
    if (open) {
      trackDwebEvent("Dweb Subscription Payment Failed Modal Opened", {
        free_trial_start_date: payments && payments.subscriptionStatus && payments.subscriptionStatus.subscriptionStartDateEpoch ? payments.subscriptionStatus.subscriptionStartDateEpoch : "",
        days_to_free_trial_expiry: payments && payments.subscriptionStatus && payments.subscriptionStatus.numberOfDays ? payments.subscriptionStatus.numberOfDays : "",
        subscription_amount: payments && payments.subscriptionPlans && payments.subscriptionPlans[0] && payments.subscriptionPlans[0].originalPrice ? payments.subscriptionPlans[0].originalPrice : "",
        amount_to_be_paid: payments && payments.subscriptionPlans && payments.subscriptionPlans[0] && payments.subscriptionPlans[0].price ? payments.subscriptionPlans[0].price : "",
        order_id: payments && payments.subscriptionStatus && payments.subscriptionStatus.orderId ? payments.subscriptionStatus.orderId : "",
      });
    }
  }, [open])

  const handleNo = () => {
    setOpen(false)
    onClose(false);
  };
  const handleYes = () => {
    trackDwebEvent("Dweb Subscription Payment Failed Try Again", {
      free_trial_start_date: payments && payments.subscriptionStatus && payments.subscriptionStatus.subscriptionStartDateEpoch ? payments.subscriptionStatus.subscriptionStartDateEpoch : "",
      days_to_free_trial_expiry: payments && payments.subscriptionStatus && payments.subscriptionStatus.numberOfDays ? payments.subscriptionStatus.numberOfDays : "",
      subscription_amount: payments && payments.subscriptionPlans && payments.subscriptionPlans[0] && payments.subscriptionPlans[0].originalPrice ? payments.subscriptionPlans[0].originalPrice : "",
      amount_to_be_paid: payments && payments.subscriptionPlans && payments.subscriptionPlans[0] && payments.subscriptionPlans[0].price ? payments.subscriptionPlans[0].price : "",
      order_id: payments && payments.subscriptionStatus && payments.subscriptionStatus.orderId ? payments.subscriptionStatus.orderId : "",
    });
    setOpen(false);
    onConfirm(true);
  };
  const handleClose = () => {
    trackDwebEvent("Dweb Subscription Payment Failed Modal Closed", {
      free_trial_start_date: payments && payments.subscriptionStatus && payments.subscriptionStatus.subscriptionStartDateEpoch ? payments.subscriptionStatus.subscriptionStartDateEpoch : "",
      days_to_free_trial_expiry: payments && payments.subscriptionStatus && payments.subscriptionStatus.numberOfDays ? payments.subscriptionStatus.numberOfDays : "",
      subscription_amount: payments && payments.subscriptionPlans && payments.subscriptionPlans[0] && payments.subscriptionPlans[0].originalPrice ? payments.subscriptionPlans[0].originalPrice : "",
      amount_to_be_paid: payments && payments.subscriptionPlans && payments.subscriptionPlans[0] && payments.subscriptionPlans[0].price ? payments.subscriptionPlans[0].price : "",
      order_id: payments && payments.subscriptionStatus && payments.subscriptionStatus.orderId ? payments.subscriptionStatus.orderId : "",
    });
    setOpen(false)
    onClose(false);
  }
  return (
    <div>
      <Dialog
        open={open}
        fullWidth
        maxWidth={'sm'}
        TransitionComponent={Transition}
        keepMounted
        disableEscapeKeyDown={true}
        disableBackdropClick={true}
        onClose={handleClose}
        aria-labelledby="payment-failed-alert-dialog-slide-title"
        aria-describedby="payment-failed-alert-dialog-slide-description"
      >
        <DialogTitle id="payment-failed-alert-dialog-slide-title" onClose={handleClose}>
          {/* <Typography variant="h6">{""}</Typography> */}
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <div className={classes.trialDiv}>
            <div>
              <PaymentFailedIcon className={classes.icon} />
            </div>
            <div>
              <h6 className={classes.unsuccessful}>Payment was unsuccessful</h6>
            </div>
            <div>
              <p className={classes.info}>If any amount deducted from your account, it will be refunded within <strong>5-7 days.</strong></p>
            </div>
          </div>
        </DialogContent>
        <DialogActions className={classes.dialogAction}>
          <Button onClick={handleYes} variant="contained" className={classes.btn} color="primary">
            {confirmText ? confirmText : 'Try Again'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentFailedAlertsDialog);